// extracted by mini-css-extract-plugin
module.exports = {"icons":"TemplateDetails_icons_1Z2jq","icon":"TemplateDetails_icon_-Jon6","text":"TemplateDetails_text_i3TYF"};